module.exports = __webpack_public_path__ + "8095d20d74d59630d2973f1009fc37b4.pdf";